import { render, staticRenderFns } from "./ACField.vue?vue&type=template&id=2318d536&scoped=true"
import script from "./ACField.vue?vue&type=script&lang=js"
export * from "./ACField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2318d536",
  null
  
)

export default component.exports